import { Component, EventEmitter, Input, OnInit, Output, ViewChild  } from '@angular/core';
import { ResetpassForm } from './resetpass';
import { ResetpassService } from './resetpass.service';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { TurnstileComponent } from '../../shared/turnstile/turnstile.component';
import { NotificationService } from '../../shared/notifications/notification.service';
import { setting } from '../../../../setting';

@Component({
	selector: 'resetpass',
	templateUrl: './resetpass.component.html',
  styleUrls: ['./resetpass.component.scss'],
	providers: [ResetpassService]
})

export class ResetpassComponent implements OnInit {
  @Input() clientSetting: any;
  @ViewChild(TurnstileComponent) turnstile?: TurnstileComponent;
  public turnstileEnabled = setting.turnstileEnabled;
  public turnstileSiteKey = setting.turnstileSiteKey;
  public turnstileToken: string | null = null;
	public resetForm : FormGroup;
	public resetError : ResetpassForm;
	public load : boolean;
  public getClientsSettingAppAuth: any;
  public showModal: boolean = false;
  public titleModal: string = '';
  public message: string = '';
  private turnstileResolve: ((token: string) => void) | null = null;
  private turnstileReject: ((error: unknown) => void) | null = null;
	@Output() finished = new EventEmitter<boolean>();
  @Output() loadResetPass = new EventEmitter<boolean>();

	constructor(
		private _resetpassService: ResetpassService,
    private formBuilder: FormBuilder,
    public notificationService: NotificationService
	)

  {

	}
  ngOnInit(): void {
     this.resetForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
		this.resetError = new ResetpassForm("");
		this.load = false;
    this.getClientsSettingAppAuth = this.clientSetting;
  }


  async onReset() {
    // El widget de Turnstile vive dentro de *ngIf="!load": hay que pedir el token
    // ANTES de prender `load`, o la pantalla de carga lo saca del DOM justo cuando necesita mostrarse.
    if (this.turnstileEnabled && !this.turnstileToken) {
      try {
        this.turnstileToken = await this.requestTurnstileToken();
      } catch (error) {
        this.notificationService.error('No se pudo completar la verificación de seguridad, intentá nuevamente.');
        return;
      }
    }

    this.loadResetPass.emit(true);
    this.load = true; // pantalla de carga

    const resetEmail = {
                          email: this.resetForm.value.email,
                          client_id: this.clientSetting.id,
                          turnstile_token: this.turnstileToken
                       };

    this._resetpassService.resetpass(resetEmail).subscribe({
        next: (data: any) => {
          this.resetTurnstile();
          this.dataResponse(data);
        },
        error: (error: HttpErrorResponse) => {
          this.load = false;
          this.resetTurnstile();

          const backendMsg = error.error?.msg as string | undefined;
          const backendDet = error.error?.det as string | undefined;

          if (backendMsg?.startsWith('CAPTCHA_')) {
            this.notificationService.error(backendDet || 'Hubo un problema con la verificación de seguridad, intentá de nuevo.');
          }
        }
    });
}

  /** Los tokens de Turnstile son de un solo uso; hay que pedir uno nuevo tras cada intento. */
  private resetTurnstile(): void {
    this.turnstileToken = null;
    this.turnstile?.reset();
  }

  /** Dispara el challenge (invisible salvo que Cloudflare necesite interacción) y espera el token. */
  private requestTurnstileToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.turnstileResolve = resolve;
      this.turnstileReject = reject;
      this.turnstile?.execute();
    });
  }

  onTurnstileVerified(token: string): void {
    this.turnstileToken = token;
    this.turnstileResolve?.(token);
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileExpired(): void {
    this.turnstileToken = null;
    this.turnstileReject?.(new Error('turnstile expired'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileError(): void {
    this.turnstileToken = null;
    this.notificationService.error('No se pudo cargar la verificación de seguridad, recargue la página.');
    this.turnstileReject?.(new Error('turnstile error'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  private dataResponse(data: any) {
      if (data.res == 1) {
        this.dataSucces();
      } else {
        this.dataFalse();
      }
      this.load = false;
  }

  private dataSucces() {
    this.openModal(true);
  }

  private dataFalse() {
    this.loadResetPass.emit(false);
    this.load = false;
    this.openModal(false);
  };

	getFinished() {
		return this.finished;
	}

  openModal(success: boolean) {
    // Mismo mensaje exista o no la cuenta: si el texto cambiara según success,
    // alguien podría probar emails uno por uno y usar esa diferencia para
    // averiguar cuáles están registrados (enumeración de usuarios).
    this.titleModal = 'Cambio de password';
    this.message = 'Si el email ingresado está registrado, vas a recibir un correo con instrucciones para restablecer tu contraseña.';
    this.showModal = true;
    if (success) {
      setTimeout(() => {
          this.finished.emit(true);
      }, 5000);
    }
  }

  closeModal() {
    this.showModal = false;

    if(this.titleModal === 'Cambio de password') {
      this.finished.emit(true);
    }
  }

  confirmAction() {
    this.closeModal();
  }


}
